import BaseButton, { ButtonProps as BaseButtonProps, ButtonHandle } from 'carbon-react/lib/components/button/__next__';

export interface ButtonProps extends BaseButtonProps {
  tabIndex?: number;
}

const Button = ({ ref, ...props }: ButtonProps & { ref?: React.Ref<ButtonHandle> }) => {
  return <BaseButton ref={ref} {...props} />;
};

export default Button;
